import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Loader } from 'js/components/common/Loader';

import { hideFooter, showFooter } from 'js/components/main/Footer/store/actions';

import style from './LayoutLoader.scss';

export const LayoutLoader = ({ isPageInPopup }) => {
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        if (isPageInPopup) {
            return;
        }

        dispatch(hideFooter());

        return () => {
            dispatch(showFooter());
        };
    }, [dispatch, isPageInPopup]);

    return (
        <div className={style.layoutLoaderContainer}>
            <Loader />
        </div>
    );
};
